import   React                 ,  
       { useState              ,
         useEffect             }  from 'react';

import   classNames               from 'classnames';

import   styles                   from './StaffMemberSheet.module.scss';

import   Field                from '../../widget/inputs/Field';
import   FieldUser                from '../../widget/inputs/FieldUser';
import   WidgetFrame              from '../../widget/navigation/WidgetFrame';
import   Trigger                  from '../../widget/actuators/Trigger';

import { User       }  from '../../../dataTypes/userManagment/types';

import { StaffMember           }  from '../../../dataTypes/legalStructureManagment/types';




import   UserSelector               from '../userManagment/UserSelector';


type StaffMemberSheetProps = {
  users?     : User[] ;
  onConfirm? : (staffMember : StaffMember) => void
  onCancel?  : () => void
}

export const StaffMemberSheet = ({ users     = [] ,
                                   onConfirm      ,
                                   onCancel       }: StaffMemberSheetProps) => {

  const [ choosenUser        , setChoosenUser        ] = useState<User|null> (null);
  const [ jobTitle           , setJobTitle           ] = useState ( '' );
  const [ email              , setEmail              ] = useState ( '' );
  const [ phoneNumber        , setPhoneNumber        ] = useState ( '' );

  const [ messageChoosenUser ] = useState ( '' );
  const [ messageJobTitle    ] = useState ( '' );
  const [ messageEmail       ] = useState ( '' );
  const [ messagePhoneNumber ] = useState ( '' );

  const [ userSelection      , setUserSelection      ] = useState ( false );

  useEffect(() => {

  }, []); 


  const handleUserSelectorHide = () => {

    setUserSelection(false);
  }

 const handleUserSelection = (user: User) => {

   setUserSelection(false);
   setChoosenUser(user);
 };

 const handleChoosenUserChange = (user: User|null) => {

   if ( user !== null )
    {
     setChoosenUser(user as User);
     setEmail ( user.email )
     setPhoneNumber ( user.phoneNumber )
    }
 };

  const handleJobTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setJobTitle ( e.target.value )
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setEmail ( e.target.value )
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setPhoneNumber ( e.target.value )
  };

  const handleCancelButtonClick = () => {
    if ( onCancel ) onCancel()
  }

  const handleValidateButtonClick = () => {

    const newStaffMember : StaffMember = {
      id          : 0,
      userId      : choosenUser?.id ?? 0,
      firstname   : choosenUser?.firstname ?? '',
      lastname    : choosenUser?.lastname ?? '',
      jobTitle    : jobTitle,
      email       : email,
      phoneNumber : phoneNumber,
    }

  if (onConfirm) onConfirm (newStaffMember)
  }

  return (
            
           <div className={classNames(styles.root)}>

               {
                userSelection &&
                <UserSelector userSet  = {users}
                              onCancel = {handleUserSelectorHide}
                              onSelect = {handleUserSelection} />
               }

               <p className={classNames(styles.title)}>
                 Ajout d'un contact 
               </p>

               <br/>

               <div className={classNames(styles.form)}>

                 <div className={classNames(styles.choosenUser)}>
                   <WidgetFrame name               = "User : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messageChoosenUser}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <FieldUser value    = {choosenUser}
                                onChange = {handleChoosenUserChange} />
                   </WidgetFrame>
				 </div> 

                 <div className={classNames(styles.jobTitle)}>
                   <WidgetFrame name               = "Poste : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messageJobTitle}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field  type     = "text"
                             value    = {jobTitle}
                             onChange = {handleJobTitleChange} />
                   </WidgetFrame>
				 </div> 

                 <div className={classNames(styles.email)}>
                   <WidgetFrame name               = "Email : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messageEmail}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field  type     = "text"
                             value    = {email}
                             onChange = {handleEmailChange} />
                   </WidgetFrame>
				 </div> 

                 <div className={classNames(styles.phoneNumber)}>
                   <WidgetFrame name               = "Téléphone : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"      
					            error              = {messagePhoneNumber}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field  type     = "text"
                             value    = {phoneNumber}
                             onChange = {handlePhoneNumberChange} />
                   </WidgetFrame>
				 </div> 

                 <div className={classNames(styles.buttons)}>
                   <div className={classNames(styles.buttons_block)}>
                        <>
                          <Trigger name="Annuler" onClick={handleCancelButtonClick} variant="tailwind2" />
                          &nbsp;&nbsp;&nbsp;
                          <Trigger name="Ajouter" onClick={handleValidateButtonClick} variant="tailwind2" />
                        </>
                  </div>
                 </div>

               </div>

           </div>
           
         );
};


export default StaffMemberSheet;
